import { resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Icon = _resolveComponent("Icon")

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["follow-btn pointer", {following: $props.following}]),
    relative: ""
  }, [
    _createVNode(_component_Icon, {
      stroke: "var(--brand-600)",
      class: "icon",
      icon: "bookmark-v2-clicked",
      "stroke-width": "1",
      width: "2rem",
      height: "2rem",
      opacity: $props.following ? 1 : 0
    }, null, 8 /* PROPS */, ["opacity"]),
    _createVNode(_component_Icon, {
      stroke: "var(--gray-600)",
      class: "icon",
      hoverable: "",
      icon: "bookmark-v2",
      "stroke-width": "1",
      fill: "var(--gray-600)",
      width: "2rem",
      height: "2rem",
      opacity: $props.following ? 0 : 1
    }, null, 8 /* PROPS */, ["opacity"])
  ], 2 /* CLASS */))
}